module.exports = __webpack_public_path__ + "static/media/ic_barchart.50f02def.svg";